<p-galleria
  ngSkipHydration
  [value]="photos()"
  [(activeIndex)]="activeIndex"
  [showIndicators]="false"
  [showIndicatorsOnItem]="'inside'"
  [circular]="true"
  [showItemNavigators]="true"
  [showThumbnails]="false"
  [showThumbnailNavigators]="false"
  [shouldStopAutoplayByClick]="true"
  class="block mb-8 slight-overflow-x relative"
>
  <ng-template pTemplate="item" let-item>
    <div class="rounded-lg thin:h-[300px] h-[340px] w-full relative">
      @if (item.last === true) {
        <img fetchpriority="high"
             [homeyImage]="'header'"
             [homeyImageSrc]="photos()[0].baseImage"
             [alt]="photos()[0].alt"
             class="block  w-full h-full max-h-full object-cover object-bottom absolute brightness-50 top-0 left-0 right-0 bottom-0"
        />
        <a pButton
           class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
           [routerLink]="initialSignupRouteIncludingInfo"
           [queryParams]="{ lotteryName: apartment().name }">
          {{ 'apartment.gallery.checkEligibility' | transloco }}
        </a>
      } @else {
       <button
         type="button"
         class="absolute z-[10] left-0 right-0 top-0 bottom-0 flex items-center justify-center cursor-pointer bg-transparent transition-colors zoom-trigger group hoverable:hover:bg-black/50 hoverable:focus-visible:bg-black/50 focus:outline-none"
         (click)="openGallery()">
         <i class="pi pi-search-plus text-white relative hidden opacity-0 hoverable:transition-opacity hoverable:group-hover:opacity-100 hoverable:group-focus-visible:opacity-100" style="font-size: 4rem"></i>
       </button>
       <img fetchpriority="high"
            [homeyImage]="'header'"
            [homeyImageSrc]="item.baseImage"
            [alt]="item.alt"
            class="block w-full h-full max-h-full object-cover object-bottom absolute top-0 left-0 right-0 bottom-0"
       />
     }
    </div>
  </ng-template>

  <ng-template pTemplate="footer" let-item>
    @if (canShare()) {
      <p-button
        (onClick)="onShare()"
        class="absolute top-2 right-2 z-10"
        styleClass="!border-transparent"
        size="small"
        icon="pi pi-share-alt"
        severity="secondary"
        [label]="'apartment.gallery.share' | transloco"
      ></p-button>
    }
    <div class="absolute bg-[--p-galleria-inset-indicator-list-background] rounded-xl px-2 text-xs bottom-2 right-2" style="color: white">
      <span>{{ activeIndex + 1 }}/{{ photos().length }}</span>
    </div>
  </ng-template>
</p-galleria>

  <p-galleria
    ngSkipHydration
    [value]="photos()"
    [(activeIndex)]="activeIndex"
    [showIndicators]="false"
    [showIndicatorsOnItem]="'inside'"
    [circular]="true"
    [showItemNavigators]="true"
    [showThumbnails]="false"
    [showThumbnailNavigators]="false"
    [fullScreen]="true"
    [(visible)]="modalOpen"
    [shouldStopAutoplayByClick]="true"
    class="block mb-8 slight-overflow-x relative"
  >
    <ng-template pTemplate="item" let-item>
      <div class="relative">
        <div
          class="absolute inset-0 z-0 flex items-center justify-center bg-surface-900/30 pointer-events-none"
        >
          <p-progressSpinner strokeWidth="4" styleClass="text-primary" />
        </div>
        @if (item.last === true) {
            <img fetchpriority="high"
                 [homeyImage]="'full'"
                 [homeyImageSrc]="photos()[0].baseImage"
                 [alt]="photos()[0].alt"
                 class="relative block h-full max-h-full brightness-50 top-0 -translate-x-0.5 left-0.5"
            />
            <div class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <a pButton>{{ 'apartment.gallery.checkEligibility' | transloco }}</a>
            </div>
        } @else {
          <img fetchpriority="high"
               [homeyImage]="'full'"
               [homeyImageSrc]="item.baseImage"
               [alt]="item.alt"
               class="relative block w-full m-auto h-full max-h-full top-0 left-0 right-0 bottom-0"
          />
        }
      </div>
    </ng-template>
  </p-galleria>
<div class="mb-8">
  <homey-page-title
    [title]="apartment().name"
    [marginStyle]="'none'"
    [atPageTop]="false"
  />

  @if (showH2()) {
    <h2 class="text-lg mb-2 font-medium">
      {{ 'apartment.housingConnect.title' | transloco }}
    </h2>
  }

  <p class="text font-medium mb-1">{{ apartment() | apartmentAddress }}</p>

  <ng-content select="[trackingBanner]"></ng-content>
</div>

<div class="block mb-6 font-medium text-surface-600 border rounded-xl border-surface-200 py-5 px-8 empty:hidden">
  <ng-content/>
</div>

<ng-content select="[apartmentUnits]"></ng-content>

@let apartmentValue = apartment();
@if (apartmentValue.type !== 'senior' && (apartmentValue.unitTypes | minRent) !== 0) {
  @let min = apartmentValue.unitTypes | estimatedSavings | min;
  @let max = apartmentValue.unitTypes | estimatedSavings | max;
  <homey-apartment-detail-info-item
    icon="pi-dollar"
    [title]="'apartment.estimatedSavings.title' | transloco"
  >
    @if (min === max) {
      <p>{{ 'apartment.estimatedSavings.single' | transloco : { value: (min | toNearestDecimal | dollar) } }}</p>
    } @else {
      <p>{{ 'apartment.estimatedSavings.range' | transloco : {
        min: (min | toNearestDecimal | dollar),
        max: (max | toNearestDecimal | dollar)
      } }}</p>
    }
  </homey-apartment-detail-info-item>
}

<homey-apartment-detail-info-item
  icon="pi-stopwatch"
  [title]="'apartment.timeline.title' | transloco"
>
  <p>
    @if (apartment().status === 'open') {
      @let state = timelineState();
      @if (state.type === 'today') {
        {{ 'apartment.timeline.closesTodayPrefix' | transloco }}
        <strong>{{ 'apartment.timeline.today' | transloco }}</strong>.
      } @else if (state.type === 'time') {
        {{ 'apartment.timeline.closesIn' | transloco }}
        <strong>
          @if (state.lessThanHour) {
            {{ 'apartment.timeline.lessThanHour' | transloco }}
          } @else {
            @if (state.days > 0) {
              {{ state.days }} {{ (state.days === 1 ? 'apartment.timeline.day' : 'apartment.timeline.days') | transloco }}
            }
            @if (state.includeHours && state.hours > 0) {
              @if (state.days > 0) {, }
              {{ state.hours }} {{ (state.hours === 1 ? 'apartment.timeline.hour' : 'apartment.timeline.hours') | transloco }}
            }
          }
        </strong>.
      } @else {
        {{ 'apartment.timeline.closedOn' | transloco : { date: (apartment().endDate | date:'MMM d') } }}
      }
    } @else {
      {{ 'apartment.timeline.closedOn' | transloco : { date: (apartment().endDate | date:'MMM d') } }}
    }
  </p>
  @if (apartment().status === 'closed') {
    <p>
    @if (!drawingDateInPast()) {
      {{ 'apartment.timeline.drawingExpectedBy' | transloco : { date: (drawingDate() | date:'MMM d') } }}
    }
  </p>
  }
</homey-apartment-detail-info-item>

<ng-container ngSkipHydration>
  <ng-content select="[otherBlocks]"></ng-content>
</ng-container>

<div class="overflow-ellipsis">
  <div
    class="mb-1 lottery-description"
    [ngClass]="{ 'max-7-lines': !showAllDescription }"
    [innerHTML]="description()"
  ></div>

  <p-button
    [outlined]="true"
    severity="contrast"
    styleClass="underline"
    [dt]="dt"
    [text]="true"
    (onClick)="toggleShowMore()"
  >
    {{ (showAllDescription ? 'apartment.description.showLess' : 'apartment.description.showMore') | transloco }}
  </p-button>
</div>

<p-divider/>

@if (apartment().amenities.length > 0) {
  <homey-page-subtitle
    ngSkipHydration
    [title]="'apartment.amenities.title' | transloco"
  />

  @let maxAmenities = 8;
  <ng-container ngSkipHydration>
    <ul class="mb-6 flex flex-col gap-2">
      @for (amenity of apartment().amenities | slice:0:(showAllAmenities ? apartment().amenities.length : maxAmenities); track amenity) {
        @let label = amenity | amenityLabel;
        @if (label) {
          <li class="flex flex-row gap-2">
            <span class="material-symbols-outlined">{{ amenity | amenityIcon }}</span>
            <!-- If amenityLabel pipe already localizes, keep as-is; otherwise wrap in Transloco: -->
            <span>{{ label }}</span>
          </li>
        }
      }
    </ul>
  </ng-container>

  @if (apartment().amenities.length > maxAmenities) {
    <p-button styleClass="w-full" [outlined]="true" severity="contrast" (onClick)="toggleShowAmenities()">
      {{ (showAllAmenities
        ? 'apartment.amenities.showLess'
        : 'apartment.amenities.showAll'
    ) | transloco : { count: apartment().amenities.length } }}
    </p-button>
  }

  <p-divider/>
}

<homey-page-subtitle
  [title]="'apartment.location.title' | transloco"
/>
<p class="mb-2">{{ apartment() | apartmentAddress }}</p>

@let url = 'https://www.google.com/maps/embed/v1/place?key=AIzaSyCVlXJPEO58xDgs6wEPFyInRIEoqRyYDeo&q=' + apartment().addressInfo.latitude + ',' + apartment().addressInfo.longitude;
@let safeUrl = url | safe;
<iframe
  class="w-full"
  height="300"
  style="border:0"
  loading="lazy"
  allowfullscreen
  referrerpolicy="no-referrer-when-downgrade"
  [src]="safeUrl"
></iframe>
